<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3 *ngIf="selectiontype=='New'">Create Organization</h3>
      <h3 *ngIf="selectiontype=='Existing'">{{ExistingOrganizationName}}</h3>
      <mat-icon class="close" (click)="closeListing(close)">close</mat-icon>
    </div>
  </div>

  <div class="dialog_content">

    <form [formGroup]="addOrganizationForm" class="fix-mat-form-field">

      <div class="field" *ngIf="selectiontype=='New'">
        <mat-form-field>
          <mat-label>Organization Name</mat-label>
          <input matInput placeholder="Organization Name" maxlength="50" formControlName="organizationName" #organizatioName>
          <mat-error>
            This field is required
          </mat-error>
        </mat-form-field>
      </div>

      <ng-container *ngIf="selectiontype=='Existing'">
        <div class="field">
          <mat-form-field>
            <mat-label>Office Name</mat-label>
            <input matInput placeholder="Office Name" maxlength="50" formControlName="officeName">
            <mat-error>
              This field is required
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>


      <div class="field">
        <mat-list-item role="listitem" class="fullw">
          <mat-form-field fxFlex class="rolesDropdown">
            <mat-select [disabled]="organizatioDomainTypeShow" placeholder="Organization Domain Type" name="role" formControlName="organizatioDomainType">
              <mat-option *ngFor="let org of organizatioDomainType" [value]="org.organizationDomainID">
                {{org.organizationDomainName}}
              </mat-option>
            </mat-select>
            <mat-error>
              This field is required
            </mat-error>
          </mat-form-field>
        </mat-list-item>
      </div>


      <div class="dataBasefields">
        <span class="dlabel">Database Setup</span>
        <div class="newExis">
          <mat-radio-group aria-label="Select an option" formControlName="selectoption" color="primary"
          [disabled]="DatabaseSetup" (change)="onRadiobuttonChange($event)">
            <mat-radio-button value="New" style="margin-right: 20px;">New</mat-radio-button>
            <mat-radio-button value="Existing">Existing</mat-radio-button>
          </mat-radio-group>
        </div>

        <div>
          <mat-list-item role="listitem" class="fullw">
            <mat-form-field fxFlex class="rolesDropdown">
              <mat-select placeholder="Database Type" name="role" formControlName="databaseType"
              [disabled]="DatabaseType" (selectionChange)="SelectiondatabaseType($event)">
                <mat-option *ngFor="let org of organizationTypeList" [value]="org.id">
                  {{org.name}}
                </mat-option>
              </mat-select>
              <mat-error>
                This field is required
              </mat-error>
            </mat-form-field>
          </mat-list-item>
        </div>

        <div *ngIf="databaseNameShow">
          <mat-form-field fxFlex>
            <mat-label>Database Name</mat-label>
            <span matPrefix>{{dbnameprefix}} &nbsp;</span>
            <input matInput placeholder="Database Name" formControlName="databaseName" maxlength="30"
            [disabled]="DatabaseName"  (keypress)="checkDbName($event)">
            <mat-error>
              This field is required
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="databaseNameShowExisting">
          <mat-form-field>
            <mat-select placeholder="Select Database Name" formControlName="databaseID" name="databaseNameExistId"
            [disabled]="SelectDatabaseName">
              <input type="text" #searchdatabaseNameExisting class="searchdata" placeholder="Search database name" matInput
                autocomplete="off">
              <mat-option *ngFor="let org of databaseNameExisting" [value]="org.databaseID">
                <span>{{org.databaseName}}</span>   <span>(Org: {{org.organizationCount}}  Office: {{org.officeCount}})</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

             
        </div>
      </div>

      <div class="dataBasefields">
        <span class="dlabel">Import Field Setup</span>
        <div>
          <mat-list-item role="listitem" class="fullw">
            <mat-form-field fxFlex class="rolesDropdown">
              <mat-select placeholder="Select Office To Import Fields" name="role" formControlName="importFields"
               (selectionChange)="SelectionImportField($event)">
                <mat-option *ngFor="let sf of importOfficeFieldList" [value]="sf.officeID">
                  {{sf.officeName}} : {{sf.domainName}}
                </mat-option>
              </mat-select>
              <mat-error>
                This field is required
              </mat-error>
            </mat-form-field>
          </mat-list-item>
        </div>
      </div>

      <div class="dataBasefields">
        <span class="dlabel">Representative Setup</span>
        <div class="flln">
          <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput placeholder="First Name" maxlength="30" formControlName="representativePersonFirstName">
            <mat-error>
              This field is required
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label> Last Name</mat-label>
            <input matInput placeholder="Last Name" maxlength="30" formControlName="representativePersonLastName">
            <mat-error>
              This field is required
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field *ngIf="selectiontype=='New'">
          <mat-label> Email</mat-label>
          <input matInput placeholder="Email" maxlength="50" formControlName="email">
          <mat-error>
            {{ getErrorEmail() }}
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="selectiontype=='Existing'" appearance="" class="mt-10 mb-10" style="position: relative;">
          <mat-label>Email</mat-label>
          <input matInput
                 maxlength="50"
                 placeholder= "Type & Select"
                 aria-label="State"
                 [matAutocomplete]="auto" 
                 (input)="searchUser($event.target.value)"
                 [formControl]="stateCtrl"
                 id="stateCtrlid">
                 <!-- <mat-error>
                  {{ getErrorEmail() }}
                </mat-error> -->
           <mat-autocomplete #auto="matAutocomplete">
            <mat-option (click)="emailSelected(email)" *ngFor="let email of emailList" [value]="email.email">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">                
                  <div class="info">                 
                    <p class="email">{{ email.email }}</p>
                  </div> 
              </span>
            </mat-option>
          </mat-autocomplete>
         
        </mat-form-field>

        <mat-form-field>
          <mat-label> Phone</mat-label>
          <span matPrefix>+1 &nbsp;</span>
          <input matInput placeholder="Phone" maxlength="10" formControlName="phoneNumber"
          (keypress)="allowOnlyNumber($event)">
          <mat-error>{{getPhoneErrorMessage()}}</mat-error>
        </mat-form-field>

        <mat-checkbox color="primary" [checked]="Setasadmin" (change)="checkSetasadmin($event)">Set as admin</mat-checkbox>


        <div  class="selectedPermission" *ngIf="OfficeUsingSelectedUser.length > 0">
          <h4 _ngcontent-rnx-c336="">Associated Office</h4>
          <div class="selList">
              <span *ngFor="let o of OfficeUsingSelectedUser">
                  <h4>{{o.officeName}}</h4>
                  <!-- <button mat-icon-button><mat-icon (click)="removeSelectedOffice(o)">cancel</mat-icon></button> -->
              </span>
          </div>
      </div>

        <mat-form-field class="choose" *ngIf="admin">
          <mat-label>Add Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" maxlength="20"
          autocomplete="off">
          <mat-icon class="eye" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-hint class="errorpass">Choose a password of at least eight characters with one uppercase
            letter, one lowercase letter, one special character and one number
          </mat-hint>
          <mat-error class="errorpass">
            {{ getErrorPassword() }}
          </mat-error>
        </mat-form-field>

      </div>

      <div class="field" >
        <mat-checkbox formControlName="isActive" color="primary" (change)="CheckStatus($event)"
          [(ngModel)]="isActiveChecked">Active</mat-checkbox>
      </div>

      <!-- <div class="field choose" *ngIf="showPasscode">

        <mat-form-field>
          <mat-label>Enter Passcode</mat-label>
          <input matInput [type]="hidecurrent ? 'password' : 'text'" placeholder="Enter Passcode"
          formControlName="superPasscode" maxlength="10" autocomplete="off">        
          <mat-error>
            This field is required
          </mat-error>
          <mat-icon matSuffix (click)="hidecurrent = !hidecurrent" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidecurrent">{{hidecurrent ? 'visibility_off' : 'visibility'}}</mat-icon> 
        </mat-form-field>

      </div>


      <div class="field">
        <div class="sendCode">
          <span *ngIf="!showPasscode">Send passcode on</span>
          <span *ngIf="showPasscode">Resend passcode on</span>

          <div class="button">
            <button mat-icon-button color="primary" (click)="showPasscode = !showPasscode">
              <mat-icon>mail</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="showPasscode = !showPasscode">
              <mat-icon>phone_iphone</mat-icon>
            </button>
          </div>
        </div>
      </div> -->



    </form>

  </div>


  <div class="actionBtn">
    <button mat-flat-button class="cancel" (click)="closeListing(close)">
      Cancel
    </button>
    <button mat-flat-button class="calltoaction" type="submit" 
      [disabled]="addOrganizationForm.invalid || !addOrganizationForm.dirty"    
      (click)="addOrganization(addOrganizationForm.value)" color="primary">Create
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </div>


</mat-card>

<div class="overlay" (click)="closeListing(close)"></div>


<!-- <app-loader></app-loader> -->